/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Marking one access notice as seen: locally, in Redux, and on the document.
 */

import { useCallback } from "react";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import {
  accessNoticesActions,
  addDismissedNotice,
  COLLECTIONS,
  firebaseDB,
  useAppDispatch,
  useAppSelector,
} from "@lemonadetraining/web-shared";

/**
 * The local record lands first because `readAt` is a round trip; the document
 * write is what dedupes the notice across this person's other devices.
 */
export function useAcknowledgeNotice(): (noticeID: string) => Promise<void> {
  const dispatch = useAppDispatch();
  const uid = useAppSelector((state) => state.user.user?.uid ?? null);

  return useCallback(
    async (noticeID: string) => {
      if (!uid || !noticeID) return;
      addDismissedNotice(uid, noticeID);
      dispatch(accessNoticesActions.acknowledge(noticeID));

      try {
        await updateDoc(
          doc(firebaseDB, COLLECTIONS.Users, uid, COLLECTIONS.AccessNotices, noticeID),
          { readAt: serverTimestamp() }
        );
      } catch (error) {
        console.warn(
          "Could not mark notice read:",
          (error as { code?: string })?.code ?? "unknown"
        );
      }
    },
    [uid, dispatch]
  );
}
